<template>
  <div>
    <div :class="{ 'full-screen': isFullScreen }">
    <el-card>
        <div v-if="showTableButtons">
        <el-button size="small" type="primary" @click="handleAdd">Add</el-button>
        <el-button size="small" type="danger" @click="handleDelete">Delete</el-button>
        <el-button @click.prevent="toggleFullScreen" size="small" type="primary" >Switch To Full Screen</el-button>

        </div>
<!--      For tableDatas, we need to check if the current display is response preview, then have to put this empty-->
      <el-table
          :data="currentField.tableDatas"
          style="width: 100%; height: fit-content; margin-bottom: 10px"
          highlight-current-row
          @row-click="handleCurrentChange"
          @selection-change="handleSelectionChange"
          @current-change="handleCurrentRowChange"
      >

        <el-table-column type="selection" width="55" v-if="showTableButtons"></el-table-column>
        <el-table-column
            v-for="(column, index) in currentField.tableColumns"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :key="index"
        >
          <template slot-scope="scope">
            <div  class="pdf-item" :componentvalue="scope.row[column.prop]">
              <el-input v-show="scope.row.edit" v-model="scope.row[column.prop]" size="small"/>
              <div v-show="!scope.row.edit">
                {{ scope.row[column.prop] }}
              </div>
            </div>

          </template>
        </el-table-column>
      </el-table>

    </el-card>
  </div>
  </div>
</template>

<script>
export default {
  name: 'TableComponent',
  props: ['currentField'],
  data() {
    return {
      isFullScreen: false,
      showTableButtons: true,
      multipleSelection: [],
      currentComponentValueArray: []
    };
  },
  methods: {
    handleCurrentChange(row) {
      if (!this.currentComponentValueArray.some((e) => e.id === row.id)) {
        this.currentComponentValueArray.push(row);
      } else {
        const objIndex = this.currentComponentValueArray.findIndex((e) => e.id === row.id);
        this.currentComponentValueArray[objIndex] = row;
      }
    },
    handleCurrentRowChange(currentRow, oldCurrentRow) {
      console.log('Current Row Change', {currentRow, oldCurrentRow});
    },
    handleDelete() {
      for (let i = 0; i < this.multipleSelection.length; i++) {
        let ele = this.multipleSelection[i];
        let index = this.currentField.tableDatas.findIndex(function (element) {
          return ele.id === element.id;
        });
        if (index >= 0) this.currentField.tableDatas.splice(index, 1);
      }
      this.multipleSelection = [];
    },
    handleAdd() {
      var columns = this.currentField.tableColumns;
      let newEle = {
        id: new Date().getTime(),
        edit: true
      };

      columns.forEach(function (ele) {
        newEle[ele.prop] = '';
      });

      this.currentField.tableDatas.push(newEle);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toggleFullScreen() {
      // Toggle the full-screen mode
      this.isFullScreen = !this.isFullScreen;

      // If entering full screen, request full screen on the container
      if (this.isFullScreen) {
        const container = document.querySelector('.full-screen');
        if (container.requestFullscreen) {
          container.requestFullscreen();
        } else if (container.mozRequestFullScreen) { // Firefox
          container.mozRequestFullScreen();
        } else if (container.webkitRequestFullscreen) { // Chrome, Safari and Opera
          container.webkitRequestFullscreen();
        } else if (container.msRequestFullscreen) { // IE/Edge
          container.msRequestFullscreen();
        }
      } else {
        // If exiting full screen, exit full screen mode
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
          document.msExitFullscreen();
        }
      }
    }
  },
  mounted() {
    if (this.currentField.componentValue && this.currentField.componentValue.length > 0) {
      const data = typeof (this.currentField.componentValue === 'object') ? this.currentField.componentValue : JSON.parse(this.currentField.componentValue);
      for (const obj of data) {
        // Check if not all values in the object are empty
        this.currentField.tableDatas.push(obj);

      }
      this.currentComponentValueArray = this.currentField.tableDatas;
    }
    this.$hub.$on('printInProgress', (data) => {
      this.showTableButtons = !data.status;
    });
  },
  watch: {
    currentComponentValueArray: {
      deep: true,
      handler(val) {
        this.currentField.componentValue = val;
      }
    }
  }
};
</script>
<style scoped>
/* Add styles for full-screen mode */
.full-screen {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff; /* Set your desired background color */
  z-index: 999;
  overflow: auto;
}
</style>
